<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Saldo Awal - Kas</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small"> Keuangan / Master / Saldo Awal / Kas</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          :loading="isLoadingExportExcel"
          icon="pi pi-file-excel"
          label="Export"
          class="p-button-outlined mr-2"
          @click="exportDataExcel"
        />
        <Button
          :loading="isLoadingExportPdf"
          icon="pi pi-print"
          label="Print"
          class="p-button-outlined"
          @click="exportDataPdf"
        />
      </div>
      <grid-kas
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        @request="onRequestData"
        @edit="onShowDialog"
      />
    </div>
    <Dialog
      :header="
        form && form.id > 0 ? 'Edit Saldo Awal Kas' : 'Tambah Saldo Awal Kas'
      "
      v-model:visible="dialogSave"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '30vw' }"
      :modal="true"
    >
      <form-kas
        :item="form"
        :loading="isLoadingSave"
        @save="onSaveData"
        @close="dialogSave = false"
      />
    </Dialog>
    <Dialog
      :header="pdfTitle"
      v-model:visible="dialogViewer"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '90vw' }"
      :modal="true"
    >
      <div>
        <embed
          :src="pdfSource"
          type="application/pdf"
          width="100%"
          height="600px"
        />
      </div>
      <template #footer>
        <Button
          type="button"
          label="Download"
          icon="pi pi-download"
          class="p-button-text mr-2"
          @click="onDownloadPdf"
        />
        <Button
          type="button"
          label="Print"
          icon="pi pi-print"
          @click="onPrintPdf"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import SaldoAwalKasService from '@/services/SaldoAwalKasService'
import errorHandler from '@/helpers/error-handler'
import GridKas from '@/components/keuangan/saldo/GridKas'
import FormKas from '@/components/keuangan/saldo/FormKas'
import { saveAs } from 'file-saver'

export default {
  components: {
    GridKas,
    FormKas,
  },
  data() {
    return {
      dataService: null,
      dialogSave: false,
      dialogViewer: false,
      faktur: 0,
      pdfSource: '',
      pdfTitle: 'PDF Viewer',
      pdfFilename: '',
      isLoading: false,
      isLoadingSave: false,
      isLoadingExportPdf: false,
      isLoadingExportExcel: false,
      items: [],
      form: {
        id: 0,
        account_id: 0,
        rekening: null,
        atas_nama: null,
        saldo_at: null,
        saldo: 0,
      },
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: 'kode',
        sortOrder: -1,
        filters: null,
      },
    }
  },
  created() {
    this.dataService = new SaldoAwalKasService()
  },
  mounted() {
    this.loadGridData()
  },
  methods: {
    onRequestData(e) {
      this.options = e
      this.loadGridData()
    },
    loadGridData() {
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.isLoading = true
      this.dataService
        .paginate(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data.data
          this.totalRecords = res.data.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Saldo Awal Kas', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onShowDialog(data) {
      this.form = Object.assign({}, data)
      this.dialogSave = true
    },
    onSaveData(data) {
      let item = {}
      item.account_id = data.id
      item.rekening = data.rekening
      item.atas_nama = data.atas_nama
      item.saldo_at = data.saldo_at
        ? dayjs(data.saldo_at).format('YYYY-MM-DD')
        : null
      item.saldo = data.saldo

      this.isLoadingSave = true
      this.dataService
        .update(item)
        .then((res) => {
          if (res.data.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Saldo Awal Kas',
              detail: 'Saldo Awal Kas berhasil diperbarui.',
              life: 3000,
            })
            this.loadGridData()
            this.dialogSave = false
          }
        })
        .catch((err) => {
          errorHandler(err, 'Saldo Awal Kas', this)
        })
        .finally(() => (this.isLoadingSave = false))
    },
    exportDataPdf() {
      this.isLoadingExport = true
      this.dataService
        .exportPdf()
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Export Saldo Awal Kas',
              detail: 'Gagal mengunduh Saldo Awal Kas.',
              life: 3000,
            })
          } else {
            const blob = new Blob([res.data], { type: 'application/pdf' })
            const pdfUrl = URL.createObjectURL(blob)
            this.pdfSource = pdfUrl + '#toolbar=0'
            this.pdfFilename = `saldo-awal-kas.pdf`
            this.pdfTitle = 'PDF Viewer (' + this.pdfFilename + ')'
            this.dialogViewer = true
          }
        })
        .catch((err) => {
          errorHandler(err, 'Export Saldo Awal Kas', this)
        })
      this.isLoadingExportPdf = false
    },
    onPrintPdf() {
      const iframe = document.createElement('iframe')
      iframe.src = this.pdfSource
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      // Use onload to make pdf preview work on firefox
      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    },
    onDownloadPdf() {
      saveAs(this.pdfSource, this.pdfFilename)
    },
    exportDataExcel() {
      this.isLoadingExportExcel = true
      this.dataService
        .exportExcel()
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Export Saldo Awal Kas',
              detail: 'Gagal mengunduh Saldo Awal Kas.',
              life: 3000,
            })
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'saldo-awal-kas.xls')
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Export Saldo Awal Kas', this)
        })
        .finally(() => (this.isLoadingExportExcel = false))
    },
  },
}
</script>
